import { Helmet } from "react-helmet";
import { useState, useMemo } from "react";
import {
  FaMagnifyingGlass,
  FaChevronLeft,
  FaChevronRight,
  FaAnglesLeft,
  FaAnglesRight,
  FaFilter,
  FaListCheck,
  FaCircleCheck,
  FaSpinner,
  FaClock,
  FaCirclePause,
  FaCircleXmark,
  FaFire,
  FaPlus,
  FaEllipsisVertical,
  FaEye,
  FaPenToSquare,
  FaTrashCan,
  FaArrowUpWideShort,
  FaUser,
} from "react-icons/fa6";
import { DashboardLayout } from "../../../components/layouts/DashboardLayout";
import { Header } from "../../../components/Header";
import { BtnDefault } from "../../../components/buttons/BtnDefault";
import { useNavigate } from "react-router-dom";

/* ============================================
   MOCK DATA JOBDESK
   ============================================ */
const MOCK_JOBDESK = [
  { id: 1, title: "Instalasi Baru - Pelanggan Paket 30 Mbps", assignee: "Ahmad Fauzi", department: "Teknisi", priority: "high", status: "in_progress", due_date: "2025-06-18T17:00:00", description: "Instalasi fiber optic ke rumah Bpk. Surya di Jl. Melati No. 15, RT 03/RW 07.", created_at: "2025-06-17T08:00:00" },
  { id: 2, title: "Perbaikan Koneksi - Gangguan Fiber Cut", assignee: "Rizky Pratama", department: "Teknisi", priority: "high", status: "in_progress", due_date: "2025-06-17T14:00:00", description: "Laporan gangguan dari area Perumahan Griya Asri, fiber putus akibat galian saluran.", created_at: "2025-06-17T09:30:00" },
  { id: 3, title: "Maintenance OLT - Firmware Update", assignee: "Dian Saputra", department: "Teknisi", priority: "medium", status: "pending", due_date: "2025-06-20T23:59:00", description: "Update firmware OLT Huawei MA5800-X7 ke versi terbaru untuk patch keamanan.", created_at: "2025-06-17T07:00:00" },
  { id: 4, title: "Input Data Stok Barang Masuk", assignee: "Siti Nurhaliza", department: "Gudang", priority: "medium", status: "in_progress", due_date: "2025-06-17T16:00:00", description: "Input 50 unit Router Mikrotik hEX S dan 100 meter Kabel UTP Cat6 ke sistem.", created_at: "2025-06-17T10:00:00" },
  { id: 5, title: "Penyusunan Laporan Bulanan Mei", assignee: "Budi Santoso", department: "Administrasi", priority: "low", status: "pending", due_date: "2025-06-25T17:00:00", description: "Menyusun laporan bulanan monitoring barang dan logistik bulan Mei 2025.", created_at: "2025-06-16T09:00:00" },
  { id: 6, title: "Survei Lokasi - Ekspansi Jaringan", assignee: "Ahmad Fauzi", department: "Teknisi", priority: "medium", status: "completed", due_date: "2025-06-16T17:00:00", description: "Survei lokasi untuk perluasan jaringan ke Perumahan Bumi Indah Blok C.", created_at: "2025-06-14T08:00:00" },
  { id: 7, title: "Pengadaan Kabel Fiber 24 Core", assignee: "Budi Santoso", department: "Administrasi", priority: "high", status: "pending", due_date: "2025-06-19T12:00:00", description: "Buat PO pengadaan 2000 meter kabel fiber optic 24 core ke supplier utama.", created_at: "2025-06-17T11:00:00" },
  { id: 8, title: "Handle Komplain Pelanggan - Speed Rendah", assignee: "Maya Putri", department: "CS", priority: "high", status: "in_progress", due_date: "2025-06-17T15:00:00", description: "Tiket #TK-20250617-003 dari pelanggan atas nama Ibu Ratna, speed hanya 5 Mbps dari 30 Mbps.", created_at: "2025-06-17T08:30:00" },
  { id: 9, title: "Stock Opname Gudang Cabang", assignee: "Siti Nurhaliza", department: "Gudang", priority: "medium", status: "pending", due_date: "2025-06-22T17:00:00", description: "Melakukan stock opname bulanan di gudang cabang Bandung dan mencocokkan dengan sistem.", created_at: "2025-06-15T09:00:00" },
  { id: 10, title: "Penggantian ONT Rusak - Pelanggan #1042", assignee: "Rizky Pratama", department: "Teknisi", priority: "low", status: "completed", due_date: "2025-06-16T14:00:00", description: "Ganti ONT ZTE F660 yang rusak di rumah pelanggan #1042 di Jl. Kenanga No. 8.", created_at: "2025-06-15T10:00:00" },
  { id: 11, title: "Pembuatan Proposal Kerjasama RT/RW Net", assignee: "Hendra Wijaya", department: "Management", priority: "high", status: "in_progress", due_date: "2025-06-21T17:00:00", description: "Buat proposal kerjasama pengelolaan jaringan RT/RW Net dengan Pengurus RW 12.", created_at: "2025-06-16T08:00:00" },
  { id: 12, title: "Konfigurasi VLAN Baru - Segmentasi Pelanggan", assignee: "Dian Saputra", department: "Teknisi", priority: "medium", status: "completed", due_date: "2025-06-15T23:59:00", description: "Konfigurasi VLAN 200-210 untuk segmentasi pelanggan di area Perumahan Melati.", created_at: "2025-06-13T09:00:00" },
  { id: 13, title: "Verifikasi Data Pelanggan Baru", assignee: "Maya Putri", department: "CS", priority: "low", status: "completed", due_date: "2025-06-16T12:00:00", description: "Verifikasi KTP dan dokumen pendaftaran 15 pelanggan baru bulan ini.", created_at: "2025-06-14T10:00:00" },
  { id: 14, title: "Perbaikan Tiang Penyangga Kabel", assignee: "Ahmad Fauzi", department: "Teknisi", priority: "high", status: "overdue", due_date: "2025-06-15T17:00:00", description: "Tiang penyangga kabel di Jl. Anggrek miring akibat angin kencang. Perlu segera diperbaiki.", created_at: "2025-06-13T11:00:00" },
  { id: 15, title: "Pembaruan Database Tarif Paket", assignee: "Hendra Wijaya", department: "Management", priority: "medium", status: "rejected", due_date: "2025-06-18T17:00:00", description: "Update harga paket internet sesuai keputusan rapat direksi tanggal 10 Juni 2025.", created_at: "2025-06-12T09:00:00" },
  { id: 16, title: "Pengelolaan Barang Rusak", assignee: "Siti Nurhaliza", department: "Gudang", priority: "low", status: "on_hold", due_date: "2025-06-20T17:00:00", description: "Klasifikasi dan proses disposal 5 unit CPE210 rusak dari hasil pemeriksaan berkala.", created_at: "2025-06-16T14:00:00" },
  { id: 17, title: "Backup Konfigurasi Mikrotik", assignee: "Dian Saputra", department: "Teknisi", priority: "low", status: "completed", due_date: "2025-06-14T23:59:00", description: "Backup seluruh konfigurasi Mikrotik (12 unit) ke server backup lokal dan cloud.", created_at: "2025-06-13T08:00:00" },
  { id: 18, title: "Follow Up Pembayaran - 5 Pelanggan", assignee: "Maya Putri", department: "CS", priority: "medium", status: "in_progress", due_date: "2025-06-18T17:00:00", description: "Follow up tagihan bulan Mei yang belum dibayarkan oleh 5 pelanggan.", created_at: "2025-06-17T07:30:00" },
  { id: 19, title: "Instalasi AP Outdoor - Area Taman", assignee: "Rizky Pratama", department: "Teknisi", priority: "medium", status: "pending", due_date: "2025-06-23T17:00:00", description: "Pasang 2 unit AP Outdoor TP-Link EAP660 HD di area taman Perumahan Griya Asri.", created_at: "2025-06-17T12:00:00" },
  { id: 20, title: "Audit Keamanan Jaringan", assignee: "Dian Saputra", department: "Teknisi", priority: "high", status: "pending", due_date: "2025-06-24T23:59:00", description: "Lakukan audit keamanan jaringan secara menyeluruh termasuk firewall dan akses remote.", created_at: "2025-06-17T13:00:00" },
  { id: 21, title: "Pelatihan Operator Gudang Baru", assignee: "Siti Nurhaliza", department: "Gudang", priority: "low", status: "on_hold", due_date: "2025-06-28T17:00:00", description: "Pelatihan penggunaan sistem monitoring barang untuk operator gudang baru, Budi.", created_at: "2025-06-16T10:00:00" },
  { id: 22, title: "Evaluasi Performa ISP Bulanan", assignee: "Hendra Wijaya", department: "Management", priority: "medium", status: "pending", due_date: "2025-06-30T17:00:00", description: "Evaluasi performa jaringan, SLA, dan kepuasan pelanggan bulan Juni 2025.", created_at: "2025-06-17T14:00:00" },
];

/* ============================================
   KONFIGURASI STATUS & PRIORITY
   ============================================ */
const StatusConfig = {
  pending: { icon: <FaClock size={12} />, label: "Menunggu", bg: "rgba(100, 116, 139, 0.12)", border: "rgba(100, 116, 139, 0.2)", text: "#94a3b8", dotBg: "rgba(100, 116, 139, 0.35)", dotBorder: "rgba(100, 116, 139, 0.45)" },
  in_progress: { icon: <FaSpinner size={12} />, label: "Diproses", bg: "rgba(59, 130, 246, 0.1)", border: "rgba(59, 130, 246, 0.2)", text: "#60a5fa", dotBg: "rgba(59, 130, 246, 0.35)", dotBorder: "rgba(59, 130, 246, 0.45)" },
  completed: { icon: <FaCircleCheck size={12} />, label: "Selesai", bg: "rgba(16, 185, 129, 0.1)", border: "rgba(16, 185, 129, 0.2)", text: "#34d399", dotBg: "rgba(16, 185, 129, 0.35)", dotBorder: "rgba(16, 185, 129, 0.45)" },
  on_hold: { icon: <FaCirclePause size={12} />, label: "Tertunda", bg: "rgba(245, 158, 11, 0.1)", border: "rgba(245, 158, 11, 0.2)", text: "#fbbf24", dotBg: "rgba(245, 158, 11, 0.35)", dotBorder: "rgba(245, 158, 11, 0.45)" },
  rejected: { icon: <FaCircleXmark size={12} />, label: "Ditolak", bg: "rgba(239, 68, 68, 0.08)", border: "rgba(239, 68, 68, 0.15)", text: "#f87171", dotBg: "rgba(239, 68, 68, 0.35)", dotBorder: "rgba(239, 68, 68, 0.45)" },
  overdue: { icon: <FaFire size={12} />, label: "Terlambat", bg: "rgba(239, 68, 68, 0.12)", border: "rgba(239, 68, 68, 0.25)", text: "#f87171", dotBg: "rgba(239, 68, 68, 0.45)", dotBorder: "rgba(239, 68, 68, 0.55)" },
};

const PriorityConfig = {
  high: { icon: <FaFire size={10} />, label: "Tinggi", bg: "rgba(239, 68, 68, 0.12)", border: "rgba(239, 68, 68, 0.22)", text: "#f87171" },
  medium: { icon: <FaArrowUpWideShort size={10} />, label: "Sedang", bg: "rgba(245, 158, 11, 0.1)", border: "rgba(245, 158, 11, 0.2)", text: "#fbbf24" },
  low: { icon: <FaArrowUpWideShort size={10} />, label: "Rendah", bg: "rgba(16, 185, 129, 0.1)", border: "rgba(16, 185, 129, 0.2)", text: "#34d399" },
};

const DepartmentConfig = {
  Teknisi: { color: "#60a5fa", bg: "rgba(59, 130, 246, 0.1)", border: "rgba(59, 130, 246, 0.2)" },
  Gudang: { color: "#fbbf24", bg: "rgba(245, 158, 11, 0.1)", border: "rgba(245, 158, 11, 0.2)" },
  Administrasi: { color: "#c084fc", bg: "rgba(168, 85, 247, 0.1)", border: "rgba(168, 85, 247, 0.2)" },
  CS: { color: "#34d399", bg: "rgba(16, 185, 129, 0.1)", border: "rgba(16, 185, 129, 0.2)" },
  Management: { color: "#fb923c", bg: "rgba(251, 146, 60, 0.1)", border: "rgba(251, 146, 60, 0.2)" },
};

/* ============================================
   HELPER
   ============================================ */
const formatDate = (dateStr) => {
  return new Date(dateStr).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" });
};

const formatDueDate = (dateStr, status) => {
  const d = new Date(dateStr);
  const now = new Date();
  const diffHr = Math.floor((d - now) / 3600000);
  const dateStr2 = d.toLocaleDateString("id-ID", { day: "numeric", month: "short" });
  const timeStr = d.toLocaleTimeString("id-ID", { hour: "2-digit", minute: "2-digit" });

  if (status === "completed" || status === "rejected") return `${dateStr2}, ${timeStr}`;
  if (diffHr < 0) return `${dateStr2}, ${timeStr}`;
  if (diffHr < 24) return `${dateStr2}, ${timeStr} (${diffHr} jam lagi)`;
  const diffDay = Math.floor(diffHr / 24);
  return `${dateStr2}, ${timeStr} (${diffDay} hari lagi)`;
};

const isOverdueCheck = (item) => {
  if (item.status === "completed" || item.status === "rejected") return false;
  return new Date(item.due_date) < new Date();
};

/* ============================================
   KOMPONEN: Skeleton
   ============================================ */
const SkeletonRow = ({ cols = 7 }) => (
  <tr className="animate-pulse">
    {Array.from({ length: cols }).map((_, i) => (
      <td key={i} className="px-4 py-3.5">
        <div className="h-3.5 bg-slate-700/60 rounded-md" style={{ width: `${30 + Math.random() * 55}%` }} />
      </td>
    ))}
  </tr>
);

const SkeletonCard = () => (
  <div className="rounded-2xl p-5 animate-pulse" style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)" }}>
    <div className="flex justify-between items-start mb-4">
      <div className="flex-1 space-y-2">
        <div className="h-4 bg-slate-700/60 rounded-md w-3/4" />
        <div className="h-3 bg-slate-700/40 rounded-md w-1/2" />
      </div>
      <div className="h-6 bg-slate-700/40 rounded-full w-16 ml-3" />
    </div>
    <div className="grid grid-cols-2 gap-3 pt-3" style={{ borderTop: "1px solid rgba(51, 65, 85, 0.15)" }}>
      {[...Array(4)].map((_, i) => (
        <div key={i} className="space-y-1.5">
          <div className="h-2.5 bg-slate-700/30 rounded w-14" />
          <div className="h-3.5 bg-slate-700/50 rounded w-20" />
        </div>
      ))}
    </div>
  </div>
);

/* ============================================
   KOMPONEN: Badges
   ============================================ */
const StatusBadge = ({ status }) => {
  const cfg = StatusConfig[status] || StatusConfig.pending;
  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap" style={{ background: cfg.bg, border: `1px solid ${cfg.border}`, color: cfg.text }}>
      {cfg.icon}
      {cfg.label}
    </span>
  );
};

const PriorityBadge = ({ priority }) => {
  const cfg = PriorityConfig[priority] || PriorityConfig.low;
  return (
    <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap" style={{ background: cfg.bg, border: `1px solid ${cfg.border}`, color: cfg.text }}>
      {cfg.icon}
      {cfg.label}
    </span>
  );
};

const DepartmentBadge = ({ dept }) => {
  const cfg = DepartmentConfig[dept] || { color: "#94a3b8", bg: "rgba(100,116,139,0.1)", border: "rgba(100,116,139,0.2)" };
  return (
    <span className="inline-flex px-2.5 py-0.5 text-xs font-semibold rounded-lg whitespace-nowrap" style={{ background: cfg.bg, border: `1px solid ${cfg.border}`, color: cfg.color }}>
      {dept}
    </span>
  );
};

/* ============================================
   KOMPONEN: SummaryCard
   ============================================ */
const SummaryCard = ({ icon, label, value, accent = "cyan", pulse = false, solid = false }) => {
  const accents = {
    cyan: { bg: solid ? "bg-cyan-600" : "bg-cyan-500/10", border: solid ? "border-cyan-600" : "border-cyan-500/20", text: solid ? "text-white" : "text-cyan-400", icon: solid ? "text-cyan-200" : "text-cyan-500", sub: solid ? "text-cyan-100" : "text-slate-500" },
    blue: { bg: solid ? "bg-blue-600" : "bg-blue-500/10", border: solid ? "border-blue-600" : "border-blue-500/20", text: solid ? "text-white" : "text-blue-400", icon: solid ? "text-blue-200" : "text-blue-500", sub: solid ? "text-blue-100" : "text-slate-500" },
    amber: { bg: solid ? "bg-amber-600" : "bg-amber-500/10", border: solid ? "border-amber-600" : "border-amber-500/20", text: solid ? "text-white" : "text-amber-400", icon: solid ? "text-amber-200" : "text-amber-500", sub: solid ? "text-amber-100" : "text-slate-500" },
    orange: { bg: solid ? "bg-orange-600" : "bg-orange-500/10", border: solid ? "border-orange-600" : "border-orange-500/20", text: solid ? "text-white" : "text-orange-400", icon: solid ? "text-orange-200" : "text-orange-500", sub: solid ? "text-orange-100" : "text-slate-500" },
    red: { bg: solid ? "bg-red-600" : "bg-red-500/10", border: solid ? "border-red-600" : "border-red-500/20", text: solid ? "text-white" : "text-red-400", icon: solid ? "text-red-200" : "text-red-500", sub: solid ? "text-red-100" : "text-slate-500" },
    emerald: { bg: solid ? "bg-emerald-600" : "bg-emerald-500/10", border: solid ? "border-emerald-600" : "border-emerald-500/20", text: solid ? "text-white" : "text-emerald-400", icon: solid ? "text-emerald-200" : "text-emerald-500", sub: solid ? "text-emerald-100" : "text-slate-500" },
    purple: { bg: solid ? "bg-purple-600" : "bg-purple-500/10", border: solid ? "border-purple-600" : "border-purple-500/20", text: solid ? "text-white" : "text-purple-400", icon: solid ? "text-purple-200" : "text-purple-500", sub: solid ? "text-purple-100" : "text-slate-500" },
  };
  const a = accents[accent] || accents.cyan;
  return (
    <div className={`relative p-4 rounded-2xl border ${a.bg} ${a.border} ${pulse ? "animate-pulse" : ""}`}>
      <div className={`mb-2 ${a.icon}`}>{icon}</div>
      <p className={`text-2xl font-bold ${a.text}`}>{value.toLocaleString("id-ID")}</p>
      <p className={`text-xs font-medium mt-0.5 ${a.sub}`}>{label}</p>
    </div>
  );
};

/* ============================================
   KOMPONEN: Select Dark
   ============================================ */
const SelectDark = ({ value, onChange, options, placeholder }) => (
  <select
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className="w-full px-3 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all appearance-none cursor-pointer"
    style={{ backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%2394a3b8' viewBox='0 0 16 16'%3E%3Cpath d='M8 11L3 6h10z'/%3E%3C/svg%3E")`, backgroundRepeat: "no-repeat", backgroundPosition: "right 12px center" }}
  >
    {placeholder && <option value="">{placeholder}</option>}
    {options.map((opt) => (
      <option key={typeof opt === "string" ? opt : opt.value} value={typeof opt === "string" ? opt : opt.value}>
        {typeof opt === "string" ? opt : opt.label}
      </option>
    ))}
  </select>
);

/* ============================================
   KOMPONEN: Action Dropdown
   ============================================ */
const ActionDropdown = ({ item }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  return (
    <div className="relative">
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
        className="p-2 rounded-lg text-slate-400 hover:text-gray-100 hover:bg-slate-700/40 transition-all"
      >
        <FaEllipsisVertical size={14} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={(e) => { e.stopPropagation(); setOpen(false); }} />
          <div
            className="absolute right-0 top-full mt-1 w-44 rounded-xl py-1.5 z-20 shadow-xl shadow-black/40"
            style={{ background: "rgba(30, 41, 59, 0.95)", border: "1px solid rgba(51, 65, 85, 0.4)", backdropFilter: "blur(12px)" }}
          >
            <button
              onClick={(e) => { 
                navigate(`/dashboard/jobdesk/detail/${item.id}`);
                e.stopPropagation(); setOpen(false); 
              }}
              className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-slate-300 hover:text-cyan-400 hover:bg-slate-700/40 transition-all"
            >
              <FaEye size={12} className="text-slate-500" />
              Lihat Detail
            </button>
            <button
              onClick={(e) => { e.stopPropagation(); setOpen(false); }}
              className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-slate-300 hover:text-cyan-400 hover:bg-slate-700/40 transition-all"
            >
              <FaPenToSquare size={12} className="text-slate-500" />
              Edit Tugas
            </button>
            <div className="my-1" style={{ borderTop: "1px solid rgba(51, 65, 85, 0.2)" }} />
            <button
              onClick={(e) => { e.stopPropagation(); setOpen(false); }}
              className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-red-400 hover:text-red-300 hover:bg-red-500/10 transition-all"
            >
              <FaTrashCan size={12} className="text-red-500/60" />
              Hapus Tugas
            </button>
          </div>
        </>
      )}
    </div>
  );
};

/* ============================================
   KOMPONEN UTAMA: JobdeskPage
   ============================================ */
export const JobdeskPage = () => {
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(MOCK_JOBDESK);

  // Filter state
  const [keyword, setKeyword] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [priorityFilter, setPriorityFilter] = useState("");
  const [deptFilter, setDeptFilter] = useState("");
  const [page, setPage] = useState(1);
  const perPage = 8;

  // Simulasi loading
  useState(() => {
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 700);
    return () => clearTimeout(t);
  });

  /* ---------- Compute real overdue status ---------- */
  const enrichedData = useMemo(() => {
    return data.map((item) => ({
      ...item,
      displayStatus: isOverdueCheck(item) ? "overdue" : item.status,
    }));
  }, [data]);

  /* ---------- Stats ---------- */
  const stats = useMemo(() => {
    const total = enrichedData.length;
    const pending = enrichedData.filter((n) => n.displayStatus === "pending").length;
    const inProgress = enrichedData.filter((n) => n.displayStatus === "in_progress").length;
    const completed = enrichedData.filter((n) => n.status === "completed").length;
    const overdue = enrichedData.filter((n) => n.displayStatus === "overdue").length;
    const highPriority = enrichedData.filter((n) => n.priority === "high" && n.status !== "completed" && n.status !== "rejected").length;
    return { total, pending, inProgress, completed, overdue, highPriority };
  }, [enrichedData]);

  /* ---------- Filtered & Paginated ---------- */
  const filteredData = useMemo(() => {
    let result = [...enrichedData];
    if (keyword.trim()) {
      const kw = keyword.toLowerCase();
      result = result.filter(
        (n) =>
          n.title.toLowerCase().includes(kw) ||
          n.assignee.toLowerCase().includes(kw) ||
          n.description.toLowerCase().includes(kw)
      );
    }
    if (statusFilter) result = result.filter((n) => n.displayStatus === statusFilter);
    if (priorityFilter) result = result.filter((n) => n.priority === priorityFilter);
    if (deptFilter) result = result.filter((n) => n.department === deptFilter);
    return result;
  }, [enrichedData, keyword, statusFilter, priorityFilter, deptFilter]);

  const totalPages = Math.max(1, Math.ceil(filteredData.length / perPage));
  const currentPage = Math.min(page, totalPages);
  const from = (currentPage - 1) * perPage;
  const to = Math.min(from + perPage, filteredData.length);
  const paginatedData = filteredData.slice(from, to);

  /* ---------- Handlers ---------- */
  const handleSearchChange = (val) => { setKeyword(val); setPage(1); };
  const handleStatusChange = (val) => { setStatusFilter(val); setPage(1); };
  const handlePriorityChange = (val) => { setPriorityFilter(val); setPage(1); };
  const handleDeptChange = (val) => { setDeptFilter(val); setPage(1); };
  const handlePageChange = (p) => setPage(p);

  const resetFilter = () => {
    setKeyword("");
    setStatusFilter("");
    setPriorityFilter("");
    setDeptFilter("");
    setPage(1);
  };

  /* ---------- Pagination Logic ---------- */
  const getPages = () => {
    const total = totalPages;
    const current = currentPage;
    const delta = 2;
    const pages = [];
    const left = Math.max(2, current - delta);
    const right = Math.min(total - 1, current + delta);
    pages.push(1);
    if (left > 2) pages.push("...");
    for (let i = left; i <= right; i++) pages.push(i);
    if (right < total - 1) pages.push("...");
    if (total > 1) pages.push(total);
    return pages;
  };

  const activeFilterCount = (statusFilter ? 1 : 0) + (priorityFilter ? 1 : 0) + (deptFilter ? 1 : 0);

  /* ---------- Row styling ---------- */
  const getRowStyle = (item) => {
    if (item.displayStatus === "overdue") return { bg: "rgba(239, 68, 68, 0.03)", hover: "rgba(239, 68, 68, 0.06)", leave: "rgba(239, 68, 68, 0.03)" };
    if (item.displayStatus === "in_progress") return { bg: "rgba(59, 130, 246, 0.02)", hover: "rgba(59, 130, 246, 0.05)", leave: "rgba(59, 130, 246, 0.02)" };
    return { bg: "transparent", hover: "rgba(0, 180, 216, 0.04)", leave: "transparent" };
  };

  /* ---------- Columns ---------- */
  const columns = [
    { key: "no", label: "No", align: "center", width: "50px" },
    { key: "title", label: "Tugas", align: "left" },
    { key: "assignee", label: "PIC", align: "left", width: "150px" },
    { key: "department", label: "Dept", align: "center", width: "110px" },
    { key: "priority", label: "Prioritas", align: "center", width: "110px" },
    { key: "status", label: "Status", align: "center", width: "120px" },
    { key: "due", label: "Tenggat", align: "left", width: "170px" },
    { key: "action", label: "", align: "center", width: "45px" },
  ];

  /* ---------- Departments for filter ---------- */
  const departments = [...new Set(MOCK_JOBDESK.map((d) => d.department))];

  return (
    <>
      <Helmet>
        <title>Jobdesk - Radius Trend</title>
        <meta name="description" content="Kelola tugas dan jobdesk tim operasional ISP / RT-RW Net." />
      </Helmet>

      <DashboardLayout showSidebar={showSidebar} setShowSidebar={setShowSidebar}>
        {/* ===== Header ===== */}
        <Header toggleSidebar={() => setShowSidebar(!showSidebar)}>
          <div className="flex items-center gap-3">
            <h2 className="text-base md:text-xl font-bold text-gray-100">
              Jobdesk
            </h2>
            <span className="hidden sm:inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-cyan-500/10 text-cyan-400 border border-cyan-500/20">
              {stats.total} tugas
            </span>
          </div>

          <div className="flex items-center gap-3">
            <BtnDefault>
              <span className="hidden lg:flex items-center gap-2">
                <FaPlus className="text-xs" />
                Buat Tugas
              </span>
              <FaPlus className="lg:hidden" />
            </BtnDefault>
          </div>
        </Header>

        {/* ===== Content ===== */}
        <main className="p-4 lg:p-6 space-y-5">

          {/* ===== Summary Cards ===== */}
          <section className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4" aria-label="Ringkasan jobdesk">
            <SummaryCard icon={<FaListCheck size={20} />} label="Total Tugas" value={stats.total} accent="cyan" />
            <SummaryCard icon={<FaClock size={20} />} label="Menunggu" value={stats.pending} accent="blue" />
            <SummaryCard icon={<FaSpinner size={20} />} label="Diproses" value={stats.inProgress} accent="purple" />
            <SummaryCard icon={<FaCircleCheck size={20} />} label="Selesai" value={stats.completed} accent="emerald" />
            <SummaryCard icon={<FaFire size={20} />} label="Terlambat" value={stats.overdue} accent="red" pulse={stats.overdue > 0} />
            <SummaryCard icon={<FaFire size={20} />} label="Prioritas Tinggi" value={stats.highPriority} accent="orange" solid pulse={stats.highPriority > 0} />
          </section>

          {/* ===== Overdue Alert Banner ===== */}
          {stats.overdue > 0 && (
            <div className="flex items-start gap-3 px-4 py-3.5 rounded-2xl bg-red-500/8 border border-red-500/20">
              <FaFire className="text-red-400 mt-0.5 shrink-0" size={16} />
              <div>
                <p className="text-sm font-bold text-red-300">Tugas Terlambat!</p>
                <p className="text-sm text-red-400/80 mt-0.5">
                  Terdapat <span className="font-bold text-red-300">{stats.overdue} tugas</span> yang melewati batas waktu penyelesaian. Segera tindak lanjuti.
                </p>
              </div>
            </div>
          )}

          {/* ===== Search & Filter ===== */}
          <section
            className="rounded-2xl p-4 sm:p-5"
            style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)", backdropFilter: "blur(12px)" }}
            aria-label="Filter dan pencarian"
          >
            <div className="flex flex-col lg:flex-row lg:items-end gap-4">
              {/* Search */}
              <div className="w-full lg:max-w-xs flex-shrink-0">
                <label htmlFor="search-jobdesk" className="block text-xs font-semibold text-slate-400 mb-1.5 uppercase tracking-wider">
                  Cari Tugas
                </label>
                <div className="relative">
                  <FaMagnifyingGlass className="absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-500 text-sm" />
                  <input
                    id="search-jobdesk"
                    type="text"
                    placeholder="Judul, PIC, deskripsi..."
                    value={keyword}
                    onChange={(e) => handleSearchChange(e.target.value)}
                    className="w-full pl-10 pr-4 py-2.5 text-sm rounded-xl bg-slate-800/60 border border-slate-600/40 text-gray-100 placeholder-slate-500 outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/20 transition-all"
                  />
                </div>
              </div>

              {/* Filters */}
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1.5">
                  <FaFilter className="text-xs text-slate-500" />
                  <span className="text-xs font-semibold text-slate-400 uppercase tracking-wider">Filter</span>
                  {activeFilterCount > 0 && (
                    <span className="min-w-[18px] h-[18px] flex items-center justify-center bg-cyan-600 text-white text-[10px] font-bold rounded-full">
                      {activeFilterCount}
                    </span>
                  )}
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
                  <SelectDark
                    value={statusFilter}
                    onChange={handleStatusChange}
                    options={[
                      { value: "pending", label: "Menunggu" },
                      { value: "in_progress", label: "Diproses" },
                      { value: "completed", label: "Selesai" },
                      { value: "on_hold", label: "Tertunda" },
                      { value: "rejected", label: "Ditolak" },
                      { value: "overdue", label: "Terlambat" },
                    ]}
                    placeholder="Semua Status"
                  />
                  <SelectDark
                    value={priorityFilter}
                    onChange={handlePriorityChange}
                    options={[
                      { value: "high", label: "Tinggi" },
                      { value: "medium", label: "Sedang" },
                      { value: "low", label: "Rendah" },
                    ]}
                    placeholder="Semua Prioritas"
                  />
                  <SelectDark
                    value={deptFilter}
                    onChange={handleDeptChange}
                    options={departments.map((d) => ({ value: d, label: d }))}
                    placeholder="Semua Dept"
                  />
                  <button
                    onClick={resetFilter}
                    className="inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium text-slate-400 border border-slate-600/40 bg-slate-800/60 hover:text-slate-200 hover:border-slate-500/50 transition-all"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* ===== Desktop Table ===== */}
          <section
            className="hidden lg:block rounded-2xl overflow-hidden"
            style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)", backdropFilter: "blur(12px)" }}
            aria-label="Tabel jobdesk"
          >
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="border-b" style={{ background: "rgba(15, 23, 42, 0.7)", borderColor: "rgba(51, 65, 85, 0.3)" }}>
                    {columns.map((col) => (
                      <th
                        key={col.key}
                        className={`px-4 py-3.5 text-xs font-semibold uppercase tracking-wider text-slate-400 ${col.align === "center" ? "text-center" : "text-left"}`}
                        style={col.width ? { width: col.width } : undefined}
                      >
                        {col.label}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody className="divide-y" style={{ borderColor: "rgba(51, 65, 85, 0.15)" }}>
                  {loading && (
                    <>{[...Array(6)].map((_, i) => <SkeletonRow key={i} cols={columns.length} />)}</>
                  )}

                  {!loading && paginatedData.length === 0 && (
                    <tr>
                      <td colSpan={columns.length} className="px-4 py-16 text-center">
                        <div className="flex flex-col items-center gap-3">
                          <div className="w-16 h-16 rounded-2xl flex items-center justify-center" style={{ background: "rgba(51, 65, 85, 0.2)", border: "1px solid rgba(51, 65, 85, 0.2)" }}>
                            <FaListCheck className="text-2xl text-slate-600" />
                          </div>
                          <div>
                            <p className="text-slate-400 font-medium">Tidak ada tugas ditemukan</p>
                            <p className="text-xs text-slate-500 mt-1">
                              {keyword || statusFilter || priorityFilter || deptFilter
                                ? "Coba ubah filter atau kata kunci pencarian"
                                : "Belum ada tugas yang terdaftar"}
                            </p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}

                  {!loading && paginatedData.map((item, index) => {
                    const style = getRowStyle(item);
                    return (
                      <tr
                        key={item.id}
                        className="transition-colors duration-150"
                        style={{ background: style.bg }}
                        onMouseEnter={(e) => { e.currentTarget.style.background = style.hover; }}
                        onMouseLeave={(e) => { e.currentTarget.style.background = style.leave; }}
                        
                      >
                        <td className="px-4 py-3 text-center text-slate-500 font-mono text-xs">
                          {from + index + 1}
                        </td>
                        <td className="px-4 py-3">
                          <div className="max-w-xs">
                            <p className={`font-semibold text-sm leading-snug ${item.displayStatus === "overdue" ? "text-red-300" : "text-gray-100"}`}>
                              {item.title}
                            </p>
                            <p className="text-xs text-slate-500 mt-0.5 truncate">{item.description}</p>
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-2">
                            <div className="w-7 h-7 rounded-lg flex items-center justify-center text-xs font-bold shrink-0" style={{ background: "rgba(51, 65, 85, 0.3)", border: "1px solid rgba(51, 65, 85, 0.3)", color: "#94a3b8" }}>
                              {item.assignee.charAt(0)}
                            </div>
                            <span className="text-sm text-slate-300 truncate">{item.assignee}</span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <DepartmentBadge dept={item.department} />
                        </td>
                        <td className="px-4 py-3 text-center">
                          <PriorityBadge priority={item.priority} />
                        </td>
                        <td className="px-4 py-3 text-center">
                          <StatusBadge status={item.displayStatus} />
                        </td>
                        <td className="px-4 py-3">
                          <span className={`text-xs whitespace-nowrap ${item.displayStatus === "overdue" ? "text-red-400 font-medium" : "text-slate-400"}`}>
                            {formatDueDate(item.due_date, item.displayStatus)}
                          </span>
                        </td>
                        <td className="px-4 py-3 text-center">
                          <ActionDropdown item={item} />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div className="flex items-center justify-between px-5 py-3.5" style={{ borderTop: "1px solid rgba(51, 65, 85, 0.2)" }}>
                <p className="text-xs text-slate-500">
                  Menampilkan <span className="text-slate-300 font-medium">{from + 1}</span> sampai{" "}
                  <span className="text-slate-300 font-medium">{to}</span> dari{" "}
                  <span className="text-slate-300 font-medium">{filteredData.length}</span>
                </p>
                <nav className="flex items-center gap-1" aria-label="Navigasi halaman">
                  <button onClick={() => handlePageChange(1)} disabled={currentPage === 1} className="p-2 rounded-lg text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 disabled:opacity-30 disabled:cursor-not-allowed transition-all" aria-label="Halaman pertama">
                    <FaAnglesLeft className="text-xs" />
                  </button>
                  <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className="p-2 rounded-lg text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 disabled:opacity-30 disabled:cursor-not-allowed transition-all" aria-label="Halaman sebelumnya">
                    <FaChevronLeft className="text-xs" />
                  </button>
                  {getPages().map((p, i) =>
                    p === "..." ? (
                      <span key={`dot-${i}`} className="px-2 text-slate-600 text-sm">···</span>
                    ) : (
                      <button
                        key={p}
                        onClick={() => handlePageChange(p)}
                        className={`min-w-[34px] h-9 px-2 rounded-lg text-sm font-medium transition-all duration-200 ${currentPage === p ? "bg-cyan-600 text-white shadow-lg shadow-cyan-600/25" : "text-slate-400 hover:text-gray-100 hover:bg-slate-700/40"}`}
                      >
                        {p}
                      </button>
                    )
                  )}
                  <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className="p-2 rounded-lg text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 disabled:opacity-30 disabled:cursor-not-allowed transition-all" aria-label="Halaman berikutnya">
                    <FaChevronRight className="text-xs" />
                  </button>
                  <button onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} className="p-2 rounded-lg text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 disabled:opacity-30 disabled:cursor-not-allowed transition-all" aria-label="Halaman terakhir">
                    <FaAnglesRight className="text-xs" />
                  </button>
                </nav>
              </div>
            )}
          </section>

          {/* ===== Mobile Card List ===== */}
          <section className="lg:hidden space-y-3" aria-label="Daftar tugas">
            {loading && (
              <>{[...Array(4)].map((_, i) => <SkeletonCard key={i} />)}</>
            )}

            {!loading && paginatedData.length === 0 && (
              <div className="rounded-2xl p-12 text-center" style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)" }}>
                <div className="w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4" style={{ background: "rgba(51, 65, 85, 0.2)", border: "1px solid rgba(51, 65, 85, 0.2)" }}>
                  <FaListCheck className="text-2xl text-slate-600" />
                </div>
                <p className="text-slate-400 font-medium">Tidak ada tugas ditemukan</p>
                <p className="text-xs text-slate-500 mt-1">
                  {keyword || statusFilter || priorityFilter || deptFilter ? "Coba ubah filter pencarian" : "Belum ada tugas"}
                </p>
              </div>
            )}

            {!loading && paginatedData.map((item) => {
              const style = getRowStyle(item);
              const isOverdue = item.displayStatus === "overdue";
              const borderColor = isOverdue ? "rgba(239, 68, 68, 0.2)" : "rgba(51, 65, 85, 0.3)";
              return (
                <article
                  key={item.id}
                  className="rounded-2xl p-4 active:scale-[0.98] transition-all duration-200"
                  style={{ background: style.bg, border: `1px solid ${borderColor}` }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = isOverdue ? "rgba(239, 68, 68, 0.3)" : "rgba(0, 180, 216, 0.2)";
                    e.currentTarget.style.background = style.hover;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = borderColor;
                    e.currentTarget.style.background = style.bg;
                  }}
                >
                  {/* Top: Title + Priority */}
                  <div className="flex justify-between items-start gap-3 mb-2.5">
                    <div className="flex-1 min-w-0">
                      <h3 className={`font-semibold text-sm leading-snug ${isOverdue ? "text-red-300" : "text-gray-100"}`}>
                        {item.title}
                      </h3>
                      <p className="text-xs text-slate-500 mt-1 line-clamp-2 leading-relaxed">{item.description}</p>
                    </div>
                    <PriorityBadge priority={item.priority} />
                  </div>

                  {/* Badges row */}
                  <div className="flex items-center gap-2 flex-wrap mb-3">
                    <StatusBadge status={item.displayStatus} />
                    <DepartmentBadge dept={item.department} />
                  </div>

                  {/* Details grid */}
                  <div className="grid grid-cols-2 gap-x-4 gap-y-2.5 pt-3" style={{ borderTop: "1px solid rgba(51, 65, 85, 0.15)" }}>
                    <div>
                      <p className="text-[10px] text-slate-500 uppercase font-semibold tracking-wider">PIC</p>
                      <div className="flex items-center gap-2 mt-0.5">
                        <div className="w-6 h-6 rounded-md flex items-center justify-center text-[10px] font-bold" style={{ background: "rgba(51, 65, 85, 0.3)", border: "1px solid rgba(51, 65, 85, 0.3)", color: "#94a3b8" }}>
                          {item.assignee.charAt(0)}
                        </div>
                        <p className="text-sm text-slate-300 truncate">{item.assignee}</p>
                      </div>
                    </div>
                    <div>
                      <p className="text-[10px] text-slate-500 uppercase font-semibold tracking-wider">Tenggat</p>
                      <p className={`text-xs font-medium mt-1 ${isOverdue ? "text-red-400" : "text-slate-400"}`}>
                        {formatDueDate(item.due_date, item.displayStatus)}
                      </p>
                    </div>
                  </div>

                  {/* Action */}
                  <div className="flex items-center justify-end mt-3 pt-2" style={{ borderTop: "1px solid rgba(51, 65, 85, 0.1)" }}>
                    <ActionDropdown item={item} />
                  </div>
                </article>
              );
            })}

            {/* Mobile Pagination */}
            {totalPages > 1 && (
              <div className="flex items-center justify-between pt-3 pb-6 px-1" style={{ borderTop: "1px solid rgba(51, 65, 85, 0.15)" }}>
                <button
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                  className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium text-slate-300 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
                  style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)" }}
                >
                  <FaChevronLeft className="text-xs" />
                  Sebelumnya
                </button>
                <span className="text-sm font-medium text-slate-400">
                  <span className="text-cyan-400">{currentPage}</span>
                  <span className="text-slate-600 mx-1">/</span>
                  {totalPages}
                </span>
                <button
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-medium text-slate-300 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
                  style={{ background: "rgba(15, 23, 42, 0.5)", border: "1px solid rgba(51, 65, 85, 0.3)" }}
                >
                  Berikutnya
                  <FaChevronRight className="text-xs" />
                </button>
              </div>
            )}
          </section>

          {/* ===== Legend ===== */}
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 px-1">
            <span className="text-[10px] text-slate-500 font-semibold uppercase tracking-wider">Status:</span>
            {Object.entries(StatusConfig).map(([key, cfg]) => (
              <div key={key} className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded-full" style={{ background: cfg.dotBg, border: `1px solid ${cfg.dotBorder}` }} />
                <span className="text-xs text-slate-400">{cfg.label}</span>
              </div>
            ))}
            <span className="mx-1 text-slate-700">|</span>
            <span className="text-[10px] text-slate-500 font-semibold uppercase tracking-wider">Prioritas:</span>
            {Object.entries(PriorityConfig).map(([key, cfg]) => (
              <div key={key} className="flex items-center gap-1.5">
                <span className="w-2.5 h-2.5 rounded-full" style={{ background: cfg.bg.replace("0.1", "0.35").replace("0.12", "0.4"), border: `1px solid ${cfg.border}` }} />
                <span className="text-xs text-slate-400">{cfg.label}</span>
              </div>
            ))}
          </div>

        </main>
      </DashboardLayout>
    </>
  );
};